import styled from 'styled-components';

import { getColor, getColorFromTheme } from '@utils/theme';

import { ColorTypes, FontSizeTypes, TintTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface ISubheadingTextProps {
	color?: ColorTypes;
	tint?: TintTypes;
	fontSize?: FontSizeTypes;
	largeFontSize?: FontSizeTypes;
	variant?: 'bold' | 'normal';
}

const SubheadingText = styled.p<ISubheadingTextProps>`
	font-family: 'Chalet', sans-serif;
	font-size: ${({ theme: components, fontSize }) =>
		fontSize ? theme.fontSizes.body[fontSize] : components.subheadingText.baseFontSize};
	line-height: 1.3;
	font-weight: ${({ variant = 'bold' }) => variant};
	color: ${({ theme: components, color, tint }) =>
		color
			? getColor(color, tint)
			: getColorFromTheme(components.bodyText.color, components.bodyText.tint)};

	@media ${theme.responsive.breakpoints.tablet} {
		font-size: ${({ theme: components, largeFontSize, fontSize }) =>
			largeFontSize
				? theme.fontSizes.body[largeFontSize]
				: fontSize
				? theme.fontSizes.body[fontSize]
				: components.subheadingText.upFontSize};
	}
`;

export default SubheadingText;
